import React from 'react';
import PropTypes from 'prop-types';

export default class FeatureLayer extends React.Component {
  static propTypes = {
    disableLink: PropTypes.bool,
    featureCollection: PropTypes.object.isRequired,
    mapboxMap: PropTypes.object,
    newTab: PropTypes.bool,
    onDefaultCoordinates: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    disableLink: false,
    newTab: false,
  };

  constructor(props, context) {
    super(props, context);

    // Adds Leaflet Feature Layer onto Mapbox
    const layer = L.mapbox.featureLayer().addTo(this.props.mapboxMap);

    this.state = {
      layer,
    };
  }

  render() {
    if (this.props.featureCollection.features.length > 0) {
      // Sets layer to feature layer object
      const layer = this.state.layer;

      // Array of markers are added to feature layer object
      layer.setGeoJSON(this.props.featureCollection);
      if (this.props.onDefaultCoordinates) {
        this.props.mapboxMap.fitBounds(layer.getBounds());
      }
      // Defines marker cluster
      const markers = new L.MarkerClusterGroup({
        // Disables blue overlay indicating scope of marker geography
        showCoverageOnHover: false,
        // Disables clustering of markers at a specific zoom level
        disableClusteringAtZoom: 12,
      });

      // Runs a function binding data to each marker layer
      layer.eachLayer((datum) => {
        // Sets custom marker icon
        datum.setIcon(L.icon(datum.feature.properties.icon));

        const popupInnerContents = `
          <span class='Map-popup-title'>${datum.feature.properties.title}</span>
          <span class='Map-popup-address'>${datum.feature.properties.address}</span>`;

        let popupContents;
        if (this.props.disableLink) {
          popupContents = `<span>${popupInnerContents}</span>`;
        } else {
          const anchorProps = [
            "class='Map-popup-a'",
            `href='${datum.feature.properties.url}'`,
          ];
          if (this.props.newTab) {
            anchorProps.push("target='_blank'");
            anchorProps.push("rel='noopener noreferrer'");
          }
          popupContents = `<a ${anchorProps.join(
            ' ',
          )}>${popupInnerContents}</a>`;
        }

        // Adds pop-up properties to each marker
        datum.bindPopup(popupContents);

        // Adds markers to marker cluster
        markers.addLayer(datum);
      });

      // Clears markers loaded by setGeoJSON function
      this.props.mapboxMap.removeLayer(layer);

      // Adds markercluster + marker abstraction back into map
      this.props.mapboxMap.addLayer(markers);
    }
    return null;
  }
}
